import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Spin } from "antd";
import { fetchActivePackages } from "../api/subscriptionPackagesApi";
import { formatMoney, startingPrice } from "../utils/pricing";
import cover from "../assets/landing/digital-service.jpeg";
import "../pages/css/pricing.css";

export default function PricingSection() {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let on = true;
    (async () => {
      try {
        setLoading(true);
        const data = await fetchActivePackages();
        if (on) setPackages(Array.isArray(data) ? data : []);
      } catch {
        if (on) setPackages([]);
      } finally {
        if (on) setLoading(false);
      }
    })();
    return () => {
      on = false;
    };
  }, []);

  const start = startingPrice(packages);
  const highlights = useMemo(
    () =>
      Array.from(
        new Set(
          packages.flatMap((pkg) =>
            (pkg.features || []).slice(0, 2).map((feature) => feature.feature_text || feature)
          )
        )
      ).slice(0, 4),
    [packages]
  );

  return (
    <section className="cl-pricing" id="plans">
      <div className="cl-container">
        <div className="cl-pricing-head">
          <p className="cl-eyebrow center">Click Law</p>
          <h2 className="cl-title center">The right legal support for individuals and businesses.</h2>
          {/* <p className="cl-pricing-lead">
            Services for families and companies in the UAE, with a clear allowance, billing cycle, and
            included support before you check out.
          </p> */}
        </div>

        {loading ? (
          <div className="cl-pricing-loading">
            <Spin />
          </div>
        ) : (
          <div className="cl-pricing-intro-grid is-single">
            <article className="cl-pricing-intro-card">
              <div className="cl-pricing-intro-media">
                <img src={cover} alt="Legal services managed on a laptop" />
              </div>
              <div className="cl-pricing-intro-body">
                <p className="cl-pricing-kicker">Legal services</p>
                <h3>Personal & Business Legal Support</h3>
                <p>
                Practical legal support for individuals, families, entrepreneurs, and businesses — tailored to your needs.
                </p>
                {start && (
                  <p className="cl-pricing-from">
                    From {formatMoney(start.price, start.currency)}
                    {start.billing_cycle === "annual" ? " / year" : " / month"}
                  </p>
                )}
                {highlights.length > 0 && (
                  <ul className="cl-pricing-intro-list">
                    {highlights.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
                <Link to="/plans/personal" className="btn btn-solid">
                  View Services
                </Link>
              </div>
            </article>
          </div>
        )}
      </div>
    </section>
  );
}
